export default __webpack_public_path__ + "static/media/AutoWF1.f22bc332.png";